module.exports = __webpack_public_path__ + "static/media/USA- Ohio.4cf01fd1.jpeg";